import React from 'react';
import ReactDOM from 'react-dom';
import LoginBox from './login-box';

import './style.css';

const podletWrapper = document.getElementById(
    'login-frontend-login-box-podlet',
);
if (podletWrapper) {
    const loggedIn = podletWrapper.getAttribute('data-logged-in') === 'true';
    ReactDOM.hydrate(<LoginBox loggedIn={loggedIn} />, podletWrapper);
}
